import express from 'express';
import { parsePayload } from '~/app/middleware';
import { deleteEntries } from '~/app/middleware/Entries';

const recycleRouter = express.Router();

recycleRouter.post('/entries{/:preview}', parsePayload, deleteEntries(true));

export default recycleRouter;
